import { MediaQuery, Text } from "@mantine/core";
import { ReactElement } from "react";
import { IResponsiveLineReturnProps } from "./types";

const LINE_RETURN = <br />;
const SPACE = <Text span>&nbsp;</Text>;

/**
 * Responsive line return component for text, default behaviour:
 * - line return on mobile
 * - space on desktop
 * @param {string} breakpoint - The Mantine breakpoint when resizing
 * @param {boolean} invert - Reverse the line return/space default behaviour: space on mobile and line return on desktop
 */
export default function ResponsiveLineReturn({
  breakpoint = "xs",
  invert = false,
}: IResponsiveLineReturnProps): ReactElement {
  return (
    <>
      <MediaQuery smallerThan={breakpoint} styles={{ display: "none" }}>
        {invert ? LINE_RETURN : SPACE}
      </MediaQuery>
      <MediaQuery largerThan={breakpoint} styles={{ display: "none" }}>
        {invert ? SPACE : LINE_RETURN}
      </MediaQuery>
    </>
  );
}
